import { ICustomer } from "../banks/types";

export class Threshold {
  id: number;
  createdAt: Date;
  maxValue: number;
  name: string;
  nick: string;
  reward: number;

  constructor(data: any) {
    this.id = data.id;
    this.createdAt = new Date(data.created_at);
    this.maxValue = data.max_value;
    this.name = data.name;
    this.nick = data.nick;
    this.reward = data.reward;
  }
}

export class Level {
  currentThreshold: Threshold;
  name: string;
  nextThreshold: Threshold;
  nick: string;
  range: number;

  constructor(data: any) {
    this.name = data.name;
    this.nick = data.nick;
    this.range = data.range;
    this.currentThreshold = new Threshold(data.current_threshold);
    this.nextThreshold = new Threshold(data.next_threshold);
  }
}

export interface IRate {
  id: number;
  currency: ICurrency;
  value: number;
  limit: number;
  updateDate?: Date;
  createDate: Date;
  deleteDate?: Date;
}

export interface ICurrency {
  id: number;
  name: string;
  chain: string;
  symbol: string;
  image: string;
  blockchainExplorerUrl: string;
  updateDate?: Date;
  createDate: Date;
  deleteDate?: Date;
}

export interface ISubCoin {
  alias: string;
  image: string;
  limit: number;
  name: string;
}

export interface IAddress {
  address: string;
  qrCode: string;
}

export interface IRank {
  customer: ICustomer;
  rankName: string;
  totalTradesUSDT: number;
  highestHigherAmountRange: number;
}

export enum ESchemes {
  default = "default",
}
